// import PropTypes from 'prop-types'
import React, { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import Toasts from '../../../Components/Toasts/Toasts.js'
// import { months } from '../workExperience/index.js'
// import TaleForProfile from './taleForProfile.jsx'
// import NewProfileDetailsView from './NewProfileDetailsView.jsx'
import ErrorHandle from '../../../Components/ErrorHandle.js'
import { dispatch } from '../../../store/reducers/persist.js'
import { setFrProUser } from '../../../store/reducers/Users/users.js'
import { ProfileApis } from '../../../API/Login/ProfileApi.js'
import AboutContentProfileCard from './AboutContentProfileCard.jsx'
import PersonalDetailsCard from './PersonalDetailsCard.jsx'
// import PersonalDetailsCard from './PersonalDetailsCard.jsx'

const NewFeaturesOfProfile = () => {
  // const [toasts, setToasts] = useState(null)
  const { frProUser } = useSelector((state) => state?.Users)
  // const workExperienceRef = React.useRef(null)
  // const qualificationsRef = React.useRef(null)
  // const handleScroll = (ref, x) => {
  //   ref?.current?.scrollBy(x, 0) // scroll the element horizontally
  // }

  const [profileData, setprofileData] = useState(undefined)
  const [toasts, setToasts] = useState(null)

  const getUserProfile = (userObj) => {
    let token = {
      fre8ProAccessToken: userObj?.fre8ProAccessToken,
      viewerUserId: userObj?.userId,
      targetUserId: userObj?.userId,
      operatedByUserId: process.env.REACT_APP_OPERATED_BY_USER_ID,
      operatedByModule: process.env.REACT_APP_OPERATED_BY_MODULE,
      clientDeviceType: process.env.REACT_APP_CLIENT_DEVICE_TYPE,
    }
    ProfileApis.getUserPersonalDetails(token)
      .then(async (resProfile) => {
        let userProfileImgObj = {
          fre8ProAccessToken: userObj?.fre8ProAccessToken,
          userId: userObj?.userId,
          profileId: resProfile?.data?.profileId,
          profileImageId: "",
          imgOriginalName: "",
          imgGeneratedName: "",
          description: "",
          uploadedAt: "",
          uploadedAtString: "",
          profileImageUrl: "",
          profileImageUrlList: [
            ""
          ],
          profileImageUrls: {
            additionalProp1: "",
            additionalProp2: "",
            additionalProp3: ""
          },
          operatedByUserId: process.env.REACT_APP_OPERATED_BY_USER_ID,
          operatedByModule: process.env.REACT_APP_OPERATED_BY_MODULE,
          clientDeviceType: process.env.REACT_APP_CLIENT_DEVICE_TYPE,
        }
        await ProfileApis.userProfileImage(userProfileImgObj)
          .then((resImg) => {
            let frProUser1 = {
              ...frProUser,
              updateProfileForm: resProfile?.data,
              profileImg: resImg?.data?.profileImageUrlList?.at(-1),
            }
            setprofileData(frProUser1)

            dispatch(
              setFrProUser({
                frProUser: {
                  ...frProUser,
                  updateProfileForm: resProfile?.data,
                  profileImg: resImg?.data?.profileImageUrlList?.at(-1),
                },
              })
            )

          })
          .catch((err) => {
            console.log('error', err)
            let customMessage = 'User image update failed'
            let type = 'User Information'
            let color = 'red'
            ErrorHandle(err, setToasts, customMessage, type, color)
          })
      })
      .catch((err) => {
        let customMessage = 'User profile details failed'
        let type = 'User Information'
        let color = 'red'
        ErrorHandle(err, setToasts, customMessage, type, color)
      })
  }

  useEffect(() => {
    getUserProfile(frProUser)
  }, []) //eslint-disable-line

  return (
    <div className="col-md-12">
      <div className="tab-content" id="v-pills-tabContent">
        <div
          className="tab-pane fade show active"
          id="v-About"
          role="tabpanel"
          aria-labelledby="v-About-tab"
          tabIndex="0">
          <AboutContentProfileCard aboutText={profileData?.updateProfileForm?.personalInfoForm?.aboutMe} />
        </div>
        <div
          className="tab-pane fade"
          id="v-PersonalDetails"
          role="tabpanel"
          aria-labelledby="v-PersonalDetails-tab"
          tabIndex="0">
          <div className="main users chart-page p-0">
            <div className="profile-bg">
              <div className="container-fluid p-lg-0">
                <PersonalDetailsCard profileData={profileData?.updateProfileForm?.personalInfoForm} />
              </div>
            </div>
          </div>
        </div>
      </div>
      {toasts && <Toasts toastsList={toasts} />}
    </div>
  )
}
export default NewFeaturesOfProfile
// NewFeaturesOfProfile.propTypes = {
//   following: PropTypes.any,
//   followers: PropTypes.any,
//   buddyList: PropTypes.any,
// }
